import { FormattedMessage } from '@alltrails/shared/react-intl';

// https://www.figma.com/file/xpgusAsl6oJxirFq2X94Wz/P_2024-Plus-Updates?type=design&node-id=1201-44935&mode=design&t=GQi2fptC9GeVoBs2-0
export default function usePlusFeatures() {
  return [
    { pro: false, text: <FormattedMessage defaultMessage="Navigate on the trail" /> },
    { pro: false, text: <FormattedMessage defaultMessage="Favorite trails and create lists" /> },
    { pro: true, text: <FormattedMessage defaultMessage="Download offline maps" /> },
    { pro: true, text: <FormattedMessage defaultMessage="Get alerts for wrong turns" /> },
    { new: true, pro: true, text: <FormattedMessage defaultMessage="Live share your activities" /> },
    { pro: true, text: <FormattedMessage defaultMessage="Access 200+ Guides" /> },
    { pro: true, text: <FormattedMessage defaultMessage="Know conditions before you go" /> },
    { pro: true, text: <FormattedMessage defaultMessage="Preview 3D Flyovers" /> },
    { pro: true, text: <FormattedMessage defaultMessage="Find trails by distance from you" /> },
    { pro: true, text: <FormattedMessage defaultMessage="Unlock more map details" /> },
    { pro: true, text: <FormattedMessage defaultMessage="Print maps for backup" /> },
    { pro: true, text: <FormattedMessage defaultMessage="Give back with 1% for the Planet" /> }
  ];
}
